<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="font-bold text-lg">
      <span class="text-gray-700">Welcome</span> to the <span class="text-gray-700">NCSS</span> app!
    </div>
    <p class="mt-6">
      In order to provide the <span class="text-gray-700 font-medium">best experience</span> possible, there are a few
      things we need to <span class="text-gray-700 font-medium">setup</span>.
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
